import React, { useRef, useState } from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { PublicBrand } from './components/PublicAppHeader';
import LandingBillDemo from './components/landing/LandingBillDemo';
import { APP_STORE_URL } from './constants/appStore';
import './design/tokens.css';
import './design/base.css';
import './LandingPage.css';

export default function LandingPage() {
  const [demoOpen, setDemoOpen] = useState(false);
  const demoTrigger = useRef<HTMLButtonElement>(null);

  function closeDemo() {
    setDemoOpen(false);
    requestAnimationFrame(() => demoTrigger.current?.focus());
  }

  return (
    <div className="vs-design landing-page">
      <a className="landing-skip" href="#main">Skip to content</a>
      <div className="landing-shell">
        <header className="landing-header">
          <PublicBrand href="/" />
          <span className="landing-header-note">For the friend who always gets the check.</span>
          <a className="vs-button vs-button--secondary" href="/app/">Sign in</a>
        </header>

        <main id="main" className="landing-main" tabIndex={-1}>
          <h1 className="landing-title">Pick up the bill.</h1>
          <p className="landing-promise">Split it in <strong>under 60 seconds.</strong></p>

          <section className="landing-story" aria-label="Try splitting an In-N-Out bill" data-demo-open={demoOpen}>
            <div className="landing-scene">
              <div className="landing-thoughts" aria-hidden="true">
                <p className="landing-thought landing-thought--fries">who had the fries?<svg viewBox="0 0 180 18"><path d="M3 9Q78 1 174 11" /></svg></p>
                <p className="landing-thought landing-thought--sam">Sam owes me…<br /><span>$10? $12?</span></p>
                <p className="landing-thought landing-thought--jo">did Jo pay me back?</p>
                <p className="landing-thought landing-thought--later">remember to ask tomorrow.</p>
                <svg className="landing-thought-arrow" viewBox="0 0 140 70"><path d="M5 9C70 0 31 64 122 45M108 32l18 12-18 13" /></svg>
              </div>

              <div className="landing-paper" aria-hidden="true">
                <span className="landing-paper-kicker">SAMPLE ORDER</span>
                <strong>In-N-Out</strong>
                <div className="landing-paper-lines"><span>2 Double-Double<i>$12.00</i></span><span>1 Cheeseburger<i>$4.00</i></span><span>3 French fries<i>$7.50</i></span><span>3 Fountain drinks<i>$7.50</i></span><span>Tax<i>$2.48</i></span></div>
                <div className="landing-paper-total"><span>You paid</span><b>$33.48</b></div>
                <small>3 FRIENDS. ONE CARD.</small>
              </div>

              {demoOpen && <LandingBillDemo onClose={closeDemo} />}
            </div>
            {!demoOpen && <div className="landing-story-control">
              <p>Your card. Everyone’s order.</p>
              <button ref={demoTrigger} type="button" onClick={() => setDemoOpen(true)}>
                Let Vibesplit split it <ArrowRight size={16} aria-hidden="true" />
              </button>
            </div>}
          </section>

          <div className="landing-invitation">
            <p>Scan the receipt. Send your friends the link.</p>
            <a className="vs-button vs-button--primary landing-download" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              Get Vibesplit for iPhone <ArrowUpRight size={17} aria-hidden="true" />
            </a>
            <span className="landing-link-note">Send friends a link. They don’t need the app.</span>
          </div>
        </main>

        <footer className="landing-footer">
          <span>Back to your night.</span>
          <nav aria-label="Footer"><a href="/support">Support</a><a href="/privacy/policy">Privacy</a><a href="/terms">Terms</a></nav>
        </footer>
      </div>
    </div>
  );
}
